// ------------------ React Components ------------------------
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import { LiaSpinnerSolid } from "react-icons/lia";

import blueKbcLogo from '../../../assets/images/branding/blue-kbc-logo.png';
import ItemAddedToaster from '../../toasterscomponents/checklistToasters/ItemAddedToaster';

import CreatedSuccesFullyToaster from '../../toasterscomponents/shepacktoasters/CreatedSuccesFullyToaster';

const ToasterViewSubAdminComponent = ({ 

  isOpen, 
  onClose, 
  selectedShePackName,
  shePackDocuments,
  isLoading,
  questionsPerDocument,

  selectedUser,

  shePackDocumentScore,

  selectedCompany,
  selectedCompanyName,
  selectedDepartment,
  selectedDepartmentName, 
  selectedUserFullName// Add this prop

}) => {
  const navigate = useNavigate();

  const [showToaster, setShowToaster] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);
 

  const [comments, setComments] = useState({});
  const [questionScores, setQuestionScores] = useState({});

  //

  

  // Calculate summary values
  const calculateSummaryValues = () => {
    if (!shePackDocuments || shePackDocuments.length === 0) {
      return {
        totalUserScore: 0,
        totalDocumentScore: 0,
        totalPercentage: 0
      };
    }

    const totalUserScore = shePackDocuments.reduce((sum, doc) => 
      sum + (parseInt(doc.user_score) || 0), 0);
    
    const totalDocumentScore = shePackDocuments.reduce((sum, doc) => 
      sum + (parseInt(doc.effective_document_score || doc.shepack_document_score) || 0), 0);
    
    // Calculate overall percentage
    const totalPercentage = totalDocumentScore > 0 
      ? Math.round((totalUserScore / totalDocumentScore) * 100) 
      : 0;
    
    return {
      totalUserScore,
      totalDocumentScore,
      totalPercentage
    };
  };

  const summaryValues = calculateSummaryValues();

  //

  const user = JSON.parse(sessionStorage.getItem('user'));

 
  

  useEffect(() => {
    // Initialize previous responses when questions are loaded
    if (questionsPerDocument) {
      Object.entries(questionsPerDocument).forEach(([documentId, categories]) => {
        Object.values(categories).forEach(questions => {
          questions.forEach(question => {
            // Handle previous comments
            if (question.previous_comment) {
              setComments(prev => ({
                ...prev,
                [question.question_id]: question.previous_comment
              }));
            }

            // Initialize scores with "Not Selected" if no previous score exists
            if (question.previous_user_question_score === undefined) {
              setQuestionScores(prev => ({
                ...prev,
                [question.question_id]: "Not Selected"
              }));
            } else {
              setQuestionScores(prev => ({
                ...prev,
                [question.question_id]: question.previous_user_question_score
              }));
            }
          });
        });
      });
    }

  }, [questionsPerDocument]);

  
  useEffect(() => {
    const timers = Object.keys(showToaster).map(key => showToaster[key] && setTimeout(() => setShowToaster(prev => ({ ...prev, [key]: false })), 3000));
    return () => timers.forEach(timer => clearTimeout(timer));
  }, [showToaster]);





 

  

  

  if (!isOpen) return null;

  return (

    <div className="checklist-question-user-fill-in-checklist-main-container">
        
        <div className="template-question-fill-in-checklist-container">
        <div className="template-fill-in-elements-container">
          <div className="user-fill-in-back-button-time-container">
            <div className='user-fill-in-back-button-container'>
              <img src={blueKbcLogo} alt="white-kbc-logo" className="add-quesiton-side-menu-logo" />
              <button type="button" onClick={onClose} className="user-fill-in-back-button"> Back</button>
            </div>
          </div>
          
          <div className="Template-fill-in-header-main-container">
            <div className="Template-fill-in-header-text-and-search-main-container">

              <div className="Template-fill-in-header-text-main-container">

                <div>
                  <div>
                    <h3>Legal Compliance - <span className="secondary-color-paragraph">Admin View She Pack Submissions Summary</span></h3>
                    <p>Selected SHE Pack : {selectedShePackName} </p>
                    <p>You are viewing submissions for <span className='secondary-color-text'>{selectedCompanyName}</span> for the following site <span className='secondary-color-text'>{selectedDepartmentName}</span></p>
                    <p>Submitted By: {selectedUserFullName} {selectedUser}</p>
                  </div>
                </div>
                
              </div>

              {/*

                <div className="Template-fill-in-header-search-main-container">

                  <div>
                    <h4 className='secondary-color-text'>Quick Questions Search</h4>
                    <div className="Template-fill-in-header-search-search-bar-container">
                      <input 
                        placeholder='Enter question name'
                        className='template-fill-in-search-bar'
                      />
                      <button className='confirm-button'>
                        <CiSearch />
                      </button>
                    </div>
                  </div>

                </div>
               
              
              */}

              
            </div>
            {isLoading ? (
              <div className="loading-spinner-container">
                <LiaSpinnerSolid className="lia-spin-solid-icon" />
              </div>
            ) : (
              <div className='template-questions-user-fill-in-main-container'>
                <div className="template-table-main-container">
                  <div className='template-table-main-header-container'>
                    <div className='template-table-header-container'>
                      
                      <div className="template-table-header">Document Name</div>
                      <div className="template-table-header">User Score</div>
                      <div className="template-table-header">Document Score</div>
                      <div className="template-table-header">Percentage</div>
                      <div className="template-table-header">Status</div>
                    </div>
                  </div>
                  <div className='template-table-body'>
                    {shePackDocuments.length === 0 ? (
                      <div className='template-table-body-row-main-container'>
                        <div className='template-table-body-row-container'>
                          <i>No documents found for this SHE Pack.</i>
                        </div>
                      </div>
                    ) : (
                      shePackDocuments.map((document, index) => (
                        <div className='template-table-body-row-main-container' key={index}>

                          <div className='she-file-submisisons-template-table-body-row-container'>

          
                            <div className='template-table-body-row-td'>{document.shepack_document_name}</div>
                            <div className='template-table-body-row-td'>  {document.user_score} </div>
                            <div className='template-table-body-row-td'>   {document.effective_document_score || document.shepack_document_score}</div>
                            <div className='template-table-body-row-td'>{document.user_percentage } %</div>
                            <div className='template-table-body-row-td'>{document.submission_status || 'No submission'}</div>
                          </div>

                        </div>
                      ))
                    )}

<div className='she-file-submisisons-total-template-table-body-row-container'>
          <div className='template-table-body-row-td'><strong>Total</strong></div>
          <div className='template-table-body-row-td'><strong>{summaryValues.totalUserScore}</strong></div>
          <div className='template-table-body-row-td'><strong>{summaryValues.totalDocumentScore}</strong></div>
          <div className='template-table-body-row-td'><strong>{summaryValues.totalPercentage} %</strong></div>
          <div className='template-table-body-row-td'></div>
        </div>

                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {showToaster.questionSaved && <ItemAddedToaster item={'Question Saved'} />}
      {showToaster.categorySaved && <ItemAddedToaster item={'Category Saved'} />}

      {showSuccess && 
        
        <CreatedSuccesFullyToaster
          heading='SHE File Filled Successfully'
        />
      }

        
    </div>
  );
};

export default ToasterViewSubAdminComponent;